import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService, NavigationService, OUTLAW_COOKIES, ProfileService } from '@outlaw/core';
import { MenuItem } from '../../interfaces';
import { MessageDialogService } from '../dialog/message-dialog.service';
import { take } from 'rxjs';
import { Router } from '@angular/router';
import { OUTLAW_COMMUNITY_ROUTES } from '../../providers/community-route.provider';

@Injectable({
  providedIn: 'root',
})
export class ProfileMenuService {
  private profileService = inject(ProfileService);
  private cookieService = inject(CookieService);
  private navigationService = inject(NavigationService);
  private authConfig = inject(ConfigService).config;
  private messageDialogService = inject(MessageDialogService);
  private router = inject(Router);
  private routes = inject(OUTLAW_COMMUNITY_ROUTES);

  getDefaultMenuItems(): MenuItem[] {
    return [
      {
        label: 'Profile',
        action: () => this.navigateToProfile(),
        dataTest: 'btn-profile-menu-item-profile',
      },
      {
        label: 'MAJI ID',
        action: () => this.openProfilePage(),
        dataTest: 'btn-profile-menu-item-maji-id',
      },
      {
        label: 'Log out',
        action: () => this.logout(),
        dataTest: 'btn-profile-menu-item-log-out',
      },
    ];
  }

  openProfilePage(): void {
    const token = this.cookieService.get(OUTLAW_COOKIES.user_token);
    const profileUrl = `${this.authConfig.profileUrl}${token}`;
    window.open(profileUrl, '_blank');
  }

  private navigateToProfile(): void {
    this.router.navigate(['/', this.routes.profile]);
  }

  private logout(): void {
    const dialogRef = this.messageDialogService.openLogoutConfirm();

    dialogRef.afterClosed$.pipe(take(1)).subscribe(result => {
      if (result) {
        this.profileService.logout();
        this.navigationService.reloadPage(this.router.url);
      }
    });
  }
}
